module.exports = __webpack_public_path__ + "img/4.fec4fe75.svg";